function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".usera{fill:#5594ff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2118.094 -6632.602)"
}, /*#__PURE__*/React.createElement("path", {
  className: "usera",
  d: "M2177.693,6689.083c-6.547-1.395-16.563-3.515-17.323-3.64l-.124-.021a6.4,6.4,0,0,1-4.4-3.151c-1.561-2.985.091-6.008,1.079-7.813,1.631-2.979,3.528-7.432,3.467-12.016a9.25,9.25,0,0,0-2.7-6.565,7.1,7.1,0,0,0-5.283-1.992c-4.944.151-7.539,4.74-7.472,8.982a25.227,25.227,0,0,0,3.612,11.852c1.642,2.784,2,5.246,1.057,7.3a6.518,6.518,0,0,1-4.585,3.414l-.082.013c-.749.128-10.444,2.3-16.373,3.63l-1.036-4.6c4.647-1.046,15.377-3.455,16.658-3.684h0c.162-.035.933-.284,1.137-.75.184-.418.058-1.413-.847-2.948a30,30,0,0,1-4.255-14.154c-.121-7.635,5.055-13.556,12.042-13.77a11.812,11.812,0,0,1,8.687,3.3,13.988,13.988,0,0,1,4.152,9.908c.074,5.608-2.143,10.868-4.017,14.292-.666,1.215-1.458,2.666-1.065,3.417a1.775,1.775,0,0,0,1.155.715c1.534.276,13.7,2.861,17.5,3.671Z",
  transform: "translate(-2.022 -3.549)"
}), /*#__PURE__*/React.createElement("path", {
  className: "usera",
  d: "M2151.094,6698.6a33,33,0,1,1,33-33A33.038,33.038,0,0,1,2151.094,6698.6Zm0-61.286a28.286,28.286,0,1,0,28.286,28.286A28.318,28.318,0,0,0,2151.094,6637.316Z"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "{width}",
    height: "{height}",
    viewBox: "0 0 66 66",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.12dcadb4.svg";
export { ForwardRef as ReactComponent };